import WHITE_FLAG from '../assets/images';

export default function extendFlagURL(arrayTo, arrayFrom) {
  const extended = arrayTo.map((country) => {
    let copyCountry = { ...country };
    const objFrom = arrayFrom.features.find((item) => {
      if (item.properties.iso2 !== country.CountryCode) {
        return false;
      }
      return item;
    });
    if (objFrom === undefined) {
      copyCountry = {
        ...copyCountry,
        flag: WHITE_FLAG,
        iso3: '',
        center: [0, 0],
      };
    } else {
      const { lat, long: lng } = objFrom.properties;
      const position = [lat, lng];
      copyCountry = {
        ...copyCountry,
        flag: objFrom.properties.flag,
        iso3: objFrom.properties.iso3,
        center: position,
      };
    }
    return copyCountry;
  });
  return extended;
}
